import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import ImageView from '../../../image-view';

import img1 from '../../../../assets/t-201/wywiad.jpg';
import './style.scss';
import DownloadButton from '../../../download-button';

type Props = {
    onComplete?: () => void
}

const Task201: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-201');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-201">
        <h2>zadanie 1</h2>
        <h3>{task?.title}</h3>
        <p>
            “Cała Polska czyta dzieciom” to kampania społeczna, która rozpoczęła się w 2001 roku czyli 20 lat temu! Zachęca ona do czytania dzieciom książek, co pomaga w ich wszechstronnym rozwoju. Wasi opiekunowie zapewne wiedzą, co lubicie czytać. Ale czy Wy wiecie, jaka jest ulubiona książka Waszych domowników?
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> pobierzcie zamieszczoną poniżej kartę wywiadu i przeprowadźcie wywiady z Waszą rodziną!
        </p>
        <div className="doc">
            <div className="image">
                <ImageView src={img1} />
            </div>
            <div className="download">
                <DownloadButton src={`${process.env.PUBLIC_URL}/assets/t-201/wywiad-czytelniczy.pdf`} file='wywiad-czytelniczy.pdf' />
            </div>
        </div>
    </div>
}

export default Task201;
